/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PharmacySlot, PharmacySlotFromJSON, PharmacySlotFromJSONTyped, PharmacySlotToJSON } from "./";

export const PharmacyOnlineCounselingSlotTypename = "PharmacyOnlineCounselingSlot" as const;

/**
 *
 * @export
 * @interface PharmacyOnlineCounselingSlot
 */
export interface PharmacyOnlineCounselingSlot {
  /**
   *
   * @type {Array<PharmacySlot>}
   * @memberof PharmacyOnlineCounselingSlot
   */
  slots: Array<PharmacySlot>;
  /**
   *
   * @type {string}
   * @memberof PharmacyOnlineCounselingSlot
   */
  weekday: PharmacyOnlineCounselingSlotWeekdayEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyOnlineCounselingSlot
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyOnlineCounselingSlotWeekdayEnum {
  Sun = "Sun",
  Mon = "Mon",
  Tue = "Tue",
  Wed = "Wed",
  Thu = "Thu",
  Fri = "Fri",
  Sat = "Sat",
}

export function PharmacyOnlineCounselingSlotFromJSON(json: any): PharmacyOnlineCounselingSlot {
  return PharmacyOnlineCounselingSlotFromJSONTyped(json, false);
}

export function PharmacyOnlineCounselingSlotFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyOnlineCounselingSlot {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyOnlineCounselingSlotTypename,

    slots: (json["slots"] as Array<any>).map(PharmacySlotFromJSON),
    weekday: json["weekday"],
  };
}

export function PharmacyOnlineCounselingSlotToJSON(object?: PharmacyOnlineCounselingSlot | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    slots: (value.slots as Array<any>).map(PharmacySlotToJSON),
    weekday: value.weekday,
  };
}
